import { Paper, Grid, Typography } from "@mui/material";
import { SubAssemblyCard } from "./SubAssemblyCard";
import { SubAssembly } from "../../../../types/subAssembly";

type Props = {
  loading: boolean;
  subAssemblies: SubAssembly[];
  onEdit: (item: SubAssembly) => void;
  onDelete: (item: SubAssembly) => void;
  onMiniPack: (item: SubAssembly) => void;
};

export function SubAssemblyGrid({
  loading,
  subAssemblies,
  onEdit,
  onDelete,
  onMiniPack,
}: Readonly<Props>) {
  if (loading) return <Typography sx={{ color: "#fff" }}>Loading...</Typography>;
  if (!subAssemblies.length) {
    return <Typography sx={{ color: "#fff" }}>No sub-assemblies found</Typography>;
  }

  return (
    <Paper
      sx={{
        flex: 1,
        p: 2,
        backgroundColor: "#111",
        border: "1px solid #333",
        overflow: "auto",
      }}
    >
      <Grid container spacing={2}>
        {subAssemblies.map((item) => (
          <Grid key={item.id} size={{ xs: 12, sm: 6, md: 4 }}>
            <SubAssemblyCard subAssembly={item} onEdit={onEdit} onDelete={onDelete} onMiniPack={onMiniPack} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
